import api from './api';

export const getTeacherDashboard = () => api.get('/analytics/teacher');
export const getStudentDashboard = () => api.get('/analytics/student');
export const getCourseAnalytics = (courseId) => api.get(`/analytics/course/${courseId}`);
export const getAdminDashboard = () => api.get('/admin/dashboard');

export const getAdvancedAnalytics = () => api.get('/analytics/advanced');
export const verifyExperiment = (data) => api.post('/analytics/experiment/verify', data);
